/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ResponseWithErrorGeneric } from '../shared/response-with-error-generic';
import { GetCustomsOfficesResponseJson } from './get-customs-offices-response-json';
import { GetCustomsOfficesResult } from '../results/get-customs-offices-result.enum';
import { IResponseWithErrorGeneric } from '../shared/iresponse-with-error-generic.interface';
import { CustomsOfficeDto } from '../models/customs-office-dto';

//<custom-head>
import { HttpResponse } from '@angular/common/http';
import { CustomsOffice } from 'cases/models';
import { orderBy } from 'lodash-es';
//</custom-head>

export class GetCustomsOfficesResponse extends ResponseWithErrorGeneric<GetCustomsOfficesResponseJson, GetCustomsOfficesResult> implements IResponseWithErrorGeneric<GetCustomsOfficesResult> {
  public offices: CustomsOfficeDto[];

  //<custom-body>
  constructor(response: HttpResponse<GetCustomsOfficesResponse>) {
    super(response, GetCustomsOfficesResult.Error);
    if (this.result !== GetCustomsOfficesResult.Success) {
      return;
    }

    this.offices = orderBy(this.body.offices.map(office => new CustomsOffice(office)), office => office.text);
  }
  //</custom-body>
}
